import { AxiosResponse, GenericAbortSignal } from 'axios';
import dataAuthorizerApi from '../apis/dataAuthorizer.api';

export type GetS3DataAuthCookiesResponse = Promise<AxiosResponse<null>>;

export const getS3DataAuthCookies = (
	signal: GenericAbortSignal,
): GetS3DataAuthCookiesResponse =>
	dataAuthorizerApi.get<null>('/v1/auth', { signal });
